import React from "react";

function HowWeWorkHero() {
  return (
    <div className="relative overflow-hidden">
      {/* Content */}
      <div className="container mx-auto px-4 md:px-8 lg:px-16 pt-20 md:pt-30 pb-16">
        <div className="max-w-6xl mx-auto">
          <h1 className="RoobertLight text-4xl md:text-5xl lg:text-6xl text-white mb-6 md:mb-8">
            How we work
          </h1>

          <h2 className="RoobertMedium text-xl md:text-2xl lg:text-3xl font-bold text-white mb-6 md:mb-8">
            Built for business outcomes. Designed to scale inside enterprise
            environments
          </h2>

          <div className="RoobertRegular space-y-4 md:space-y-6 text-base md:text-lg text-white">
            <p>
              Every OBZ engagement begins with a commitment to make real change
              happen - not just recommend it.
            </p>
            <p>
              We blend strategic clarity with engineering execution, deploying
              hybrid teams of experienced consultants and AI coworkers to help
              clients move faster, operate smarter, and scale sustainably.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HowWeWorkHero;
